import { defineStore } from "pinia";
import { ref } from "vue";
import Api from "@/model/api";

export const useIpStore = defineStore("ip", () => {
  const ip = ref("");

  let ipPromise = null;

  const useIp = async () => {
    // 如果已经有 IP 地址，直接返回
    if (ip.value) {
      return ip.value;
    }

    // 如果正在获取 IP 地址，返回 Promise
    if (ipPromise) {
      return ipPromise;
    }

    // 获取 IP 地址
    ipPromise = (async () => {
      try {
        const fetchedIp = await Api.fetchIpAddress();
        ip.value = fetchedIp;
        return ip.value;
      } catch (error) {
        console.error("Error in useIp:", error);
        throw error;
      } finally {
        ipPromise = null;
      }
    })();

    return ipPromise;
  };

  return { useIp };
});
